module.exports = __webpack_public_path__ + "img/proj3.a364f242.png";